import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { faBank, faCreditCard, faPlus, faSpinner, faStore, faTrashCan, faTruckMoving } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Column, ColumnEditorOptions, ColumnEvent } from "primereact/column";
import { DataTable, DataTableFilterMeta, DataTableFilterMetaData } from "primereact/datatable";
import { InputText } from "primereact/inputtext";

import iconYape from '../../../../assets/img/icon-yape.png';

import debounce from "lodash.debounce";
import { confirmDialog } from "primereact/confirmdialog";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import FormattedDate from "../../../../Shared/Components/FormatDate";
import { orderStatus, OrderStatusCancelled } from '../enum/OrderEnums';
import './Orders.css';
import OrderViewModel from "./OrderViewModel";
import { useToast } from "../../../../Shared/hook/useToast";
interface ColumnMeta {
    field: string;
    header: string;
    editable: boolean;
}
export const Orders = () => {
    const title = "Ordenes";
    
    // const toast = useRef(null);
    const { showSuccess, showError, showWarn, showInfo } = useToast();
    
    const [totalRecords, setTotalRecords] = useState(0); 
    const [filters, setFilters] = useState<DataTableFilterMeta>({ global: { value: null, matchMode: FilterMatchMode.CONTAINS }});

    const [colorFilterTipoPago, setColorFilterTipoPago] = useState("");
    const [iconBtnFilterTipoPago, setIconBtnFilterTipoPago] = useState(faPlus);
    const [valueFilterTipoPago, setValueFilterTipoPago] = useState<number>();

    const [colorFilterTipoEntrega, setColorFilterTipoEntrega] = useState("");
    const [iconBtnFilterTipoEntrega, setIconBtnFilterTipoEntrega] = useState(faPlus);
    const [valueFilterTipoEntrega, setValueFilterTipoEntrega] = useState<number>();

    const [colorFilterEstado, setColorFilterEstado] = useState("");
    const [nameFilterEstado, setNameFilterEstado] = useState("Estado");
    const [iconBtnFilterEstado, setIconBtnFilterEstado] = useState(faPlus);
    const [valueFilterEstado, setValueFilterEstado] = useState<number>();
    
    const [dateInit, setDateInit] = useState("");
    const [dateEnd, setDateEnd] = useState("");

    const columns: ColumnMeta[] = [
        { field: 'options', header: 'Opciones', editable: false },
        { field: 'orderCode', header: 'Código', editable: false },
        { field: 'customerFirstname', header: 'Cliente', editable: false },
        { field: 'created', header: 'Fecha registro', editable: false },
        { field: 'orderStatus', header: 'Estado', editable: false },
        { field: 'paymentMethod', header: 'Tipo de pago', editable: false },
        { field: 'deliveryMethod', header: 'Tipo de entrega', editable: false },
        { field: 'total', header: 'Total', editable: false }
    ];

    type LazyParamsType = {
        first: number;
        rows: number;
    };
            
    const [loading, setLoading] = useState(false);
    const [lazyParams, setLazyParams] = useState<LazyParamsType>({
        first: 0,
        rows: 10,
    });
    const {
        getOrders,
        orders,
        updateOrderStatus
    } = OrderViewModel();

    useEffect(() => {
            const orderCode = (filters['global'] as DataTableFilterMetaData)?.value || '';
            loadOrders(lazyParams.first ?? 0, lazyParams.rows ?? 10, orderCode);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lazyParams, filters]);

    const loadOrders = async (
        first: number, 
        rows: number, 
        orderCode: string, 
        sortOrder: string = 'desc',
        orderStatus?: number, 
        PaymentMethod?: number, 
        DeliveryMethod?: number, 
        fromDate: string = '', 
        toDate: string = '', 
        sortColumn: string = 'created'
        ) => {
        setLoading(true);
        const page = Math.floor(first / rows);
        //const search = filters?.global?.value || '';

        try {
            const result = await getOrders(page+1, rows, orderCode, sortOrder, orderStatus, PaymentMethod, DeliveryMethod, fromDate, toDate, sortColumn);
             
            setTotalRecords(result.totalCount);
        } catch (error) {
            console.error("Error al cargar Banners", error);
        } finally {
            setLoading(false);
        }
    };

    const isPositiveInteger = (val: any) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };
    
    const onCellEditComplete = (e: ColumnEvent) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'order':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;
            default:
                if (newValue.trim().length > 0) {
                    rowData[field] = newValue;
                    // UpdateTableProductView(rowData);
                }
                else event.preventDefault();
                break;
        }
    };
    
    
    const cellEditor = (options: ColumnEditorOptions) => {
        // if (options.field === 'state') return noTextEditor();
        // else return textEditor(options);
        return textEditor(options);
    };
    
    const textEditor = (options: ColumnEditorOptions) => {
        return (
            <InputText
                type="text"
                value={options.value || ''} // Asegúrate de que options.value no sea nulo o indefinido
                onChange={(e) => options.editorCallback!(e.target.value)} 
            />
        );
    };
    
        //  const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        //     const value = event.target.value;
        //     const _filters: DataTableFilterMeta = {
        //         ...filters,
        //         global: {
        //             value,
        //             matchMode: 'contains', // <- tipo válido, no 'string' genérico
        //         },
        //         };
    
        //     setFilters(_filters);
    
        //         // Si está vacío, recarga productos
        //         if (!value.trim()) {
        //             loadOrders(lazyParams.first ?? 0, lazyParams.rows ?? 10, value);
        //         }
        // };

    //  Guardamos el texto en un estado normal
    const [inputValue, setInputValue] = useState("");
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedSearch = useCallback(
      debounce((sortOrder: string) => {
        loadOrders(lazyParams.first ?? 1, lazyParams.rows ?? 10, sortOrder);
      }, 500),
      [lazyParams]
    );
    
    // Limpieza del debounce al desmontar
    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);


    const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        
        setInputValue(value.trim());
        // solo dispara la búsqueda cuando hay un valor completo
        if (value.trim().length > 0) {
        
            debouncedSearch(value.trim());
        } else {
            // Si está vacío, recargar todo sin filtro
            loadOrders(lazyParams.first, lazyParams.rows, "");
        } 
    };

    const optionFilterTipoPago = ( value: number)=> {
        setValueFilterTipoPago(value);
        switch (value) {
            case 0:
                setColorFilterTipoPago("bg-link");
                setIconBtnFilterTipoPago(faTrashCan);
                break;
            case 1:
                setColorFilterTipoPago("bg-bank");
                setIconBtnFilterTipoPago(faCreditCard);
                break;
            case 2:
                setColorFilterTipoPago("bg-credit");
                setIconBtnFilterTipoPago(faBank);
                break;
            case 3:
                setColorFilterTipoPago("bg-yape");
                break;
            default:
                setColorFilterTipoPago("");
                break;
            }
    }

    const optionFilterTipoEntrega = ( value: number)=>{
        setValueFilterTipoEntrega(value)
        switch (value) {
                case 0:
                    setColorFilterTipoEntrega("bg-tienda");
                    setIconBtnFilterTipoEntrega(faStore);
                    break;
                case 1:
                    setColorFilterTipoEntrega("bg-delivery");
                    setIconBtnFilterTipoEntrega(faTruckMoving);
                    break;
                default:
                    setColorFilterTipoEntrega("");
                    break;
            }
    }

    const optionFilterEstado = ( value: number)=>{
        setValueFilterEstado(value);
        switch (value) {
                case 0:
                    setColorFilterEstado("bg-generado");
                    setNameFilterEstado("Generado");
                    break;
                case 1:
                    setColorFilterEstado("bg-pendiente");
                    setNameFilterEstado("Pendiente");
                    break;
                case 2:
                    setColorFilterEstado("bg-enviado");
                    setNameFilterEstado("Enviado");
                    break;
                case 3:
                    setColorFilterEstado("bg-entregado");
                    setNameFilterEstado("Entregado");
                    break;
                case 4:
                    setColorFilterEstado("bg-anulado");
                    setNameFilterEstado("Anulado");
                    break;
                case 5:
                    setColorFilterEstado("bg-cancelado");
                    setNameFilterEstado("Cancelado");
                    break;
                case 6:
                    setColorFilterEstado("bg-confirmado");
                    setNameFilterEstado("Confirmado");
                    break;
                case 7:
                    setColorFilterEstado("bg-recojo");
                    setNameFilterEstado("Recojo");
                    break;
                default:
                    setColorFilterEstado("");
                    setNameFilterEstado("Estado");
                    break;
            }
    }

    const SendFilter = () =>{
        console.log("dateInit", dateInit);
        console.log("dateEnd", dateEnd);
        const orderCode = (filters['global'] as DataTableFilterMetaData)?.value || '';
        loadOrders(lazyParams.first ?? 0, lazyParams.rows ?? 10, orderCode, "", valueFilterEstado, valueFilterTipoPago, valueFilterTipoEntrega, dateEnd, dateInit );

    }
    const cleanFilter = (clean:boolean)=> {
        if(clean===true){
            setColorFilterTipoPago("");
            setIconBtnFilterTipoPago(faPlus);
            setColorFilterTipoEntrega("");
            setIconBtnFilterTipoEntrega(faPlus);
            setColorFilterEstado("");
            setIconBtnFilterEstado(faPlus);
            setNameFilterEstado("Estado");
            setDateInit("");
            setDateEnd("");
            setValueFilterEstado(undefined);
            setValueFilterTipoPago(undefined);
            setValueFilterTipoEntrega(undefined);
            const orderCode = (filters['global'] as DataTableFilterMetaData)?.value || '';
            loadOrders(lazyParams.first ?? 0, lazyParams.rows ?? 10, orderCode);
        }
    }
    
    const header = ()=>{
        // @ts-ignore
        //const value = (filters['global'] as DataTableFilterMetaData)?.value || '';

    return (
        <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
            <div className="m-0">
                {/* <div className="d-flex gap-3">
      
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-4">
                        Menu 3
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                        <Dropdown.Item onClick={() => optionFilterTipoPago(1)}>
                            Item X
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => optionFilterTipoPago(2)}>
                            Item Y
                        </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div> */}
                <div className="d-flex gap-2">
                    <div className="form-group">
                        <input type="date" value={dateInit} onChange={(e)=> setDateInit(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <input type="date" value={dateEnd} onChange={(e)=> setDateEnd(e.target.value)} />
                    </div>
                    <div className="btn-group" role="group">
                        <Dropdown>
                            <Dropdown.Toggle variant="light" className={`btn btn-outline-danger dropdown-toggle ${colorFilterTipoPago}`} id="dropdown-filter-1">
                                {colorFilterTipoPago==="bg-yape" ? (
                                <>
                                    <img style={{"width": "22px"}} src={iconYape} alt="img-yape" /> Tipo de pago
                                </>
                            )
                            :(
                                    <>
                                    <FontAwesomeIcon icon={iconBtnFilterTipoPago} /> Tipo de pago
                                    </>
                            )}
                            </Dropdown.Toggle>
                            <Dropdown.Menu align="start">
                                <Dropdown.Item className="bg-item-bank"  onClick={() => optionFilterTipoPago(1)}>
                                    <FontAwesomeIcon icon={icon({name: 'bank'})} /> Transf. bancaria
                                </Dropdown.Item>
                                <Dropdown.Item className="bg-item-credit" onClick={() => optionFilterTipoPago(2)}>
                                    <FontAwesomeIcon icon={icon({name: 'credit-card'})} /> Tarj. crédito
                                </Dropdown.Item>
                                 <Dropdown.Item className="bg-item-yape" onClick={() => optionFilterTipoPago(3)}>
                                    <img className="img-yape" src={iconYape} alt="img-yape" /> Yape
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <div className="btn-group" role="group">
                         <Dropdown>
                            <Dropdown.Toggle variant="light" id="dropdown-filter-2" className={`btn btn-outline-danger dropdown-toggle ${colorFilterTipoEntrega}`}>
                                <FontAwesomeIcon icon={iconBtnFilterTipoEntrega} /> Tipo de entrega
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item className="bg-item-tienda" onClick={() => optionFilterTipoEntrega(0)}>
                                    <FontAwesomeIcon icon={icon({name: 'store'})} /> Recojo en tienda
                                </Dropdown.Item>
                                <Dropdown.Item className="bg-item-delivery" onClick={() => optionFilterTipoEntrega(1)}>
                                    <FontAwesomeIcon icon={icon({name: 'truck-moving'})} /> Envío a domicilio
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <div className="btn-group" role="group">
                             <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-filter-3" className={`btn btn-outline-danger dropdown-toggle ${colorFilterEstado}`}>
                                    <FontAwesomeIcon icon={iconBtnFilterEstado} /> {nameFilterEstado}
                                </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                    <Dropdown.Item className="bg-item-generado" onClick={() => optionFilterEstado(0)}>
                                        Generado
                                    </Dropdown.Item>
                                    <Dropdown.Item className="bg-item-pendiente" onClick={() => optionFilterEstado(1)}>
                                        Pendiente
                                    </Dropdown.Item>
                                    <Dropdown.Item className="bg-item-enviado" onClick={() => optionFilterEstado(2)}>
                                        Enviado
                                    </Dropdown.Item>
                                    <Dropdown.Item className="bg-item-entregado" onClick={() => optionFilterEstado(3)}>
                                        Entregado
                                    </Dropdown.Item>
                                    <Dropdown.Item className="bg-item-anulado" onClick={() => optionFilterEstado(4)}>
                                        Anulado
                                    </Dropdown.Item>
                                    <Dropdown.Item className="bg-item-cancelado" onClick={() => optionFilterEstado(5)}>
                                        Cancelado
                                    </Dropdown.Item>
                                    <Dropdown.Item className="bg-item-confirmado" onClick={() => optionFilterEstado(6)}>
                                        Confirmado
                                    </Dropdown.Item>
                                    <Dropdown.Item className="bg-item-recojo" onClick={() => optionFilterEstado(7)}>
                                        Recojo
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                    </div>
                    <button type="button" className="btn btn-dark" onClick={()=>SendFilter()}>
                        <FontAwesomeIcon icon={icon({name: 'filter-circle-dollar'})} /> filtrar
                    </button>
                    <button type="button" className="btn btn-info" onClick={()=>cleanFilter(true)}>
                        <FontAwesomeIcon icon={icon({name: 'rotate-right'})} /> Limpiar
                    </button>
                </div>
            </div>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" value={inputValue}  onChange={onGlobalFilterChange} placeholder="Buscar código de orden..." />
            </span>
        </div>
    )};

    const orderStatusOptions = (data: any)=> {
        let name: string = "";
        let styleColor: string ="";
            
            switch (data) {
                case 0:
                    name = "Generado";
                    styleColor="badge rounded-pill bg-generado";
                    break;
                case 1:
                    name = "Pendiente";
                    styleColor="badge rounded-pill bg-pendiente";
                    break;
                case 2:
                    name = "Enviado";
                    styleColor="badge rounded-pill bg-enviado";
                    break;
                case 3:
                    name = "Entregado";
                    styleColor="badge rounded-pill bg-entregado";
                    break;
                case 4:
                    name = "Anulado";
                    styleColor="badge rounded-pill bg-anulado";
                    break;
                case 5:
                    name = "Cancelado";
                    styleColor="badge rounded-pill bg-cancelado";
                    break;
                case 6:
                    name = "Confirmado";
                    styleColor="badge rounded-pill bg-confirmado";
                    break;
                case 7:
                    name = "Recojo ";
                    styleColor="badge rounded-pill bg-recojo ";
                    break;
                default:
                    name = "";
                    styleColor="badge rounded-pill bg-light";
                    break;
            }
        return(
            <div className={`${styleColor}`}>
                {name}
            </div>
        );
    };

    const CustomerData = (data: any) =>{
         return(
            <div>{data.customerFirstname} {data.customerLastName}</div>
        );
    }

    const deliveryMethodOptions = (data: any)=> {
            let name: string = "";
            let config: any;
        switch (data) {
                case 0:
                    name = "Recojo en Tienda";
                    config = { iconName: faStore, style: 'text-danger fs-3'};
                    break;
                case 1:
                    name = "Envío a Domicilio";
                    config = { iconName: faTruckMoving, style: 'text-info fs-3' };
                    break;
                default:
                    name = "";
                    config = { iconName: faSpinner, style: '' };
                    break;
            }
        return(
            <div className={`d-flex flex-column align-items-center`}>
                <section className={`${config.style}`}>
                    <FontAwesomeIcon icon={config.iconName} />
                </section>
                {name}
            </div>
        );
    }


    const totalOptions = (total: any)=> {
        const totalFormat = "S/ " + total.toFixed(2); ;
        return(
            <div>{totalFormat}</div>
        );
    };

    const paymentMethodOptions = (data: any)=> {
        
        let config: any;
            
            switch (data) {
                case 1:
                    config = { iconName: faBank, style: 'bg-bank-content bg-bank' };
                    break;
                case 2:
                    config = { iconName: faCreditCard, style: 'bg-credit-content bg-credit' };
                    break;
                case 3:
                        config = { style: 'bg-yape-content bg-yape' };
                    break;
                default:
                    config = { iconName: faSpinner, style: 'fs-3' };
                    break;
            }
            
            return(
            <div className={`content-icon-table`} >
                <div className={`${config.style} `}>
                    { data===3 ? (
                        <img style={{"width": "40px"}} src={iconYape} alt="img-yape" />
                    ):(
                        <FontAwesomeIcon icon={config.iconName} />
                    )}
                </div>
            </div>
        );
    };

    const btnOptions = (data: any)=> {
    
        // console.log(id.toString());
        return( 
            <div className="d-inline">
                <div className="btn-group" role="group">
                    <button id={`btnGroupDrop${data.id}`} type="button" className="btn btn-dark dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        Opc
                    </button>
                    <ul className="dropdown-menu" aria-labelledby={`btnGroupDrop${data.id}`}>
                        <li><a className="dropdown-item" href={`/orders-detail/${data.id}`} >Ver detalle</a></li>
                        { (data.orderStatus !== orderStatus.ENTREGADO && data.orderStatus !== orderStatus.CONFIRMADO && data.orderStatus !== orderStatus.ANULADO) &&
                           <>
                            <li><button className="dropdown-item" onClick={()=>confirmUpdateStatus(data.id, orderStatus.ANULADO, OrderStatusCancelled.OrderCancelledOne)}>Anular por desistimiento de compra</button></li>
                            <li><button className="dropdown-item" onClick={()=>confirmUpdateStatus(data.id, orderStatus.ANULADO, OrderStatusCancelled.OrderCancelledTwo)}>Anular por quiebre de stock</button></li>
                            <li><button className="dropdown-item" onClick={()=>confirmUpdateStatus(data.id, orderStatus.ANULADO, OrderStatusCancelled.OrderCancelledThree)}>Anular por presunto fraude</button></li>
                           </>
                        }
                       
                    </ul>
                </div>
            </div>
        );
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const updateStatus = async (id: number, status:number, typeCancelled: number) => {

        let sendData = {
            orderId: id,
            orderStatus: status,
            OrderTypeCancelled: typeCancelled
        }
        const updatingStatus = await updateOrderStatus(sendData);
        if(updatingStatus===true) {
            const orderCode = (filters['global'] as DataTableFilterMetaData)?.value || '';
            loadOrders(lazyParams.first ?? 0, lazyParams.rows ?? 10, orderCode);
            showSuccess('Actualizando','El estado se actualizo correctamente!');
        }
    }

    // const show = (severity: any, summary: any, detail: any) => {
    //     // @ts-ignore
    //     toast.current.show({ severity: `${severity}`, summary: `${summary}`, detail: `${detail}`});
    // };
    const reject = () => {
            showWarn('Rechazada','has rechazado');
        }
    
    const confirmUpdateStatus = useCallback((id: number, status: number, typeCancelled: number) => {
        confirmDialog({
            message: '¿Quieres Anular la orden?',
            header: 'Confirmar anulación',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-info',
            acceptLabel: 'Sí',
            rejectLabel: 'No',
            accept: () => updateStatus(id, status, typeCancelled),
            reject,
        });
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [updateStatus]);
      
    return(
        <div className='container-fluid'>
            
            {/* <Toast ref={toast} /> */}
            <div className="block-header">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                        <h2>Listado de Ordenes</h2>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                            </li>
                            <li className="breadcrumb-item">{title}</li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-flex flex-row-reverse">
                            
                            <div className="p-2 d-flex">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='title-report'>
                    Aquí puedes ver las últimas ordenes generadas
                </div>   
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <DataTable 
                        value={ orders || []}
                        lazy 
                        paginator 
                        rows={lazyParams.rows} 
                        first={lazyParams.first} 
                        totalRecords={totalRecords} 
                        loading={loading} 
                        editMode="cell" 
                        rowsPerPageOptions={[5, 10, 15, 20]} 
                        tableStyle={{ minWidth: '50rem', minHeight: '300px' }} 
                        onPage={(e) => setLazyParams({first: e.first, rows: e.rows})} 
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}" 
                        // paginatorLeft={paginatorLeft} paginatorRight={paginatorRight}  
                        globalFilterFields={['order', 'type']} 
                        emptyMessage="No se encontraron banners." stateStorage="session"
                        header={header} 
                        filters={filters} 
                        onFilter={(e) => {
                            setFilters(e.filters); 
                            setLazyParams((prev) => ({ ...prev, first: 0 })); // Reinicia a página 0
                        }}
                        >
                        {columns.map(({ field, header, editable  }) => {
                                    return <Column 
                                    key={field} 
                                    field={field} 
                                    header={header}
                                    body={(rowData) => {
                                        if (!rowData) return null;
                                
                                        switch (field) {
                                        case "options":
                                                return (
                                                <>
                                                    {btnOptions(rowData)}
                                                    
                                                </>
                                            );
                                            case "created":
                                            return  <FormattedDate value={rowData.created} />;
                                            case "customerFirstname":
                                            return CustomerData(rowData);
                                            case "orderStatus":
                                            return orderStatusOptions(rowData.orderStatus);
                                            case "paymentMethod":
                                            return paymentMethodOptions(rowData.paymentMethod);
                                            
                                            case "deliveryMethod":
                                                return deliveryMethodOptions(rowData.deliveryMethod);
                                        //   case "imagePrimary":
                                        //       return imgBanner(rowData);
                                            case "total":
                                                return totalOptions(rowData.total);
                                            
                                        default:
                                            return rowData[field];
                                        }
                                        //return rowData[field];
                                    }}
                
                                    editor={editable ? (options) => cellEditor(options) : undefined} 
                                    onCellEditComplete={onCellEditComplete}
                                    />
                            })
                        }
                    </DataTable>
                </div>
            </div>
        </div>
    );
}
